import { useParams } from 'react-router-dom';
import { useClientSideCache } from './use-client-side-cache';

/**
 * Returns the tenant from the URL parameters or from the client-side cache.
 * If the tenant from the URL parameters does not match the one from the cache,
 * it returns the one from the cache.
 * If neither of them is provided, it returns undefined.
 *
 * @returns { tenant: string | undefined }
 */
export const useTenant = () => {
  const { tenant: paramsTenant } = useParams();
  const { tenant: cacheTenant } = useClientSideCache();
  const normalizedParamsTenant = paramsTenant?.trim();
  const normalizedCacheTenant = cacheTenant?.trim();

  if (normalizedParamsTenant && normalizedCacheTenant) {
    if (normalizedParamsTenant !== normalizedCacheTenant) {
      return { tenant: normalizedCacheTenant };
    }

    return { tenant: normalizedParamsTenant };
  }

  // Fallback to whichever source is available so tenant-scoped APIs can run.
  return { tenant: normalizedParamsTenant || normalizedCacheTenant || undefined };
};
